import { css } from '@emotion/react'
import { QRCodeSVG } from 'qrcode.react'
import { useTranslation } from 'react-i18next'
import { Divider, Link, Spacer, Text } from '@/components'
import CenteredPageTemplate from '@/components/layout/page-templates/CenteredPageTemplate'
import testLabels from '../DeeplinkValidation.labels'

interface FallbackPageProps {
  deeplinkFallbackUrl: string
  product?: string
  deeplinkUrl: string
}

const FallbackPage = ({
  deeplinkFallbackUrl,
  product,
  deeplinkUrl,
}: FallbackPageProps) => {
  const { i18n, t } = useTranslation()

  return (
    <CenteredPageTemplate size="small" title={t('FallbackPageTitle')}>
      <Text>{t(`FallbackPageDescription_${product}`)}</Text>
      <Spacer
        css={css`
          width: 100%;
        `}
        type="my-5"
      >
        <Divider />
      </Spacer>
      {t('FallbackPageGooglePlayStoreButtonDescription')}
      <Spacer type="m-5">
        <Link
          href={deeplinkFallbackUrl}
          testDataLabel={testLabels.googlePlayStoreLink}
        >
          <img
            alt="Get it on Google Play"
            src={`${myESET.envData.HomeAssetUrl}/images/googlePlayBadges/${i18n.language}/google-play-badge.png`}
            width={160}
          />
        </Link>
      </Spacer>
      <Spacer type="mb-5">
        <Text>{t('FallbackPageGooglePlayStoreQRCodeDescription')}</Text>
      </Spacer>
      <Spacer type="m-5">
        <QRCodeSVG size={200} value={deeplinkUrl} />
      </Spacer>
    </CenteredPageTemplate>
  )
}

export default FallbackPage
